import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page2',
  name: 'pre_close_in_page2',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page2',
      name: 'pre_close_in_page2',
      component: () => import('@/views/pre_settle/pre_close/in/index2'),
      meta: {
        title: 'pre_close_in_page2',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
